import { render, staticRenderFns } from "./Advantage.vue?vue&type=template&id=3c0190a8&scoped=true"
import script from "./Advantage.vue?vue&type=script&lang=ts"
export * from "./Advantage.vue?vue&type=script&lang=ts"
import style0 from "./Advantage.vue?vue&type=style&index=0&id=3c0190a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0190a8",
  null
  
)

export default component.exports